import { Controller } from "@hotwired/stimulus"

// Balão de flash: entra deslizando da direita e some sozinho depois de `delay` ms.
export default class extends Controller {
  static values = { delay: { type: Number, default: 2000 } }

  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove("translate-x-4", "opacity-0")
    })
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.classList.add("translate-x-4", "opacity-0")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
    setTimeout(() => this.element.remove(), 400) // fallback se transitionend não disparar
  }
}
